import { Component, OnInit, forwardRef, ViewChild, AfterViewInit } from '@angular/core';
import * as _ from 'underscore';
import moment from 'moment';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { OverlayPanelComponent } from '@otas/utils/custom-components/overlay-panel/overlay-panel.component';
@Component({
    selector: 'app-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TimePickerComponent),
            multi: true
        },
    ],
    standalone: false
})
export class TimePickerComponent implements OnInit, ControlValueAccessor, AfterViewInit {
  @ViewChild(OverlayPanelComponent, { static: false }) overLayPanel: OverlayPanelComponent;
  hours = _.range(1, 13).map(e => e < 10 ? ('0' + e) : '' + e);
  // 0..59 — range(0, 61) used to offer an invalid "60" minutes option
  minutes = _.range(0, 60).map(e => e < 10 ? ('0' + e) : '' + e);
  onChange = (_f: any) => { };
  onTouched = () => { };
  selectedHour = '12';
  selectedMin = '00';
  timePeriod = 'AM';
  constructor() {

  }
  ngAfterViewInit() {
    this.overLayPanel.afterHide.subscribe(()=>{
      this.hide()
    })
  }
  ngOnInit() {
  }

  registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState?(isDisabled: boolean): void {

  }
  writeValue(obj: any): void {

    if (!!obj) {
      
      const splitTime = obj.split(':');
      this.selectedHour = splitTime[0];
      this.selectedMin = splitTime[1].split(' ')[0];
      this.timePeriod = obj.split(' ')[1];

    } else {
      this.selectedHour = '12';
      this.selectedMin = '00';
      this.timePeriod = 'AM';
    }

  }
  timeChange() {
    this.onChange(this.selectedHour + ':' + this.selectedMin + ' ' + this.timePeriod)
  }
  show(eve) {
    this.overLayPanel.show(eve);
  }
  hide() {
    this.overLayPanel.hide();

  }
}
